angular.module('pitch.app')
    .directive('skipToMainContent', function($location, $timeout) {
        "use strict";
        return {
            restrict: 'A',
            link: function(scope, element) {

                var scrollDownToMain = function() {
                    var hashId = 'main_content';
                    var wrapperId = 'main_content_wrapper';

                    $timeout(function() {
                        $location.hash(hashId);
                        document.getElementById(wrapperId).focus();
                    });
                };

                element.bind("keydown keypress", function (event) {
                    if(event.which === 13) {
                        // Number 13 is "Enter" -, especially important for accessibility
                        scrollDownToMain();
                    }

                });

                element.on('click', function() {
                    scrollDownToMain();
                });


            }
        };
    })
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/skipToMainContent.js